export default function() {
  const widgetName = 'mainFeature';
  const widgetOpts = mainFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(){
        const button = $(this).find('.moreButton');
        button.addClass('button');

        const title = $(this).find('.card-widget-title');
        const titleText = title.text();
        const characterLimit = 50;

        if (titleText.length > characterLimit) {
          const trimmedText = titleText.substring(0, characterLimit);
          title.text(trimmedText);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['image'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: true, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 0,
      navText: ['Prev','Next'],
      nav: true,
      dots: true,
      autoplay: true
    },
    textOverImage: false
  });

}